export default "__VITE_ASSET__Ueoa65cz__"